import { createAsyncThunk } from "@reduxjs/toolkit";
import type { ReportCreationTask } from "types";
import { apiGet, apiPost } from "utilities/api";
import { REPORTS_FIRST_RUN_STATUS_FOLDER_PATH, SCOPES } from "utilities/constants/constants";

export const createReports = createAsyncThunk(
	"reports/createReports",
	apiPost(
		(authConfig) => authConfig.REPORTS_API_ENDPOINTS.CREATE_REPORTS(),
		[SCOPES.REPORTS_WRITE],
	),
);

export const fetchReportsCreationStatus = createAsyncThunk(
	"reports/fetchReportsCreationStatus",
	apiGet<ReportCreationTask[]>(
		(authConfig) =>
			authConfig.DATA_LAKE_API_ENDPOINTS.GET_CUSTOMER_DATA(
				REPORTS_FIRST_RUN_STATUS_FOLDER_PATH,
			),
		[SCOPES.DATA_LAKE_READ],
	),
);
